<template>
  <div v-if="cardTypeList.length > 0 || (cardTypeList.length == 0 && !isStore)" class="pack_menu_list">
    <!-- <img
      src="/img/menu_left.png"
      class="arrow"
      id="left-arrow"
      alt=""
      @click="scrollLeft"
    > -->
    <div class="menu-wrapper">
      <div v-if="cardTypeList.length == 0" class="menu" id="menu">
        <div
          class="menu-item"
          id="menu-item"
          :class="{ active: showCardType == 999996 }"
          @click="selectPackType(999996)"
        >MIX</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 2 }"
          @click="selectPackType(2)"
          >Pokemon</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 1 }"
          @click="selectPackType(1)"
        >Yu-Gi-Oh</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 5 }"
          @click="selectPackType(5)"
        >ONE PIECE</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 3 }"
          @click="selectPackType(3)"
        >Weiss Schwarz</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 9999 }"
          @click="selectPackType(9999)"
          >Hobby</div>
      </div>
      <div class="menu" id="menu">
        <div
          v-for="cardType in cardTypeList"
          :key="cardType.id"
          class="menu-item"
          :class="{ active: showCardType == cardType.id }"
          @click="selectPackType(cardType.id)"
        >{{ t(cardType.name) }}</div>
      </div>
    </div>
    <!-- <img
      src="/img/menu_right.png"
      class="arrow"
      id="right-arrow"
      alt=""
      @click="scrollRight"
    > -->
  </div>
</template>

<script>
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';

export default {
  mixins: [t],

  computed: {
    ...mapGetters({
      showCardType: 'pack/topCardType',
    }),
  },
  props: {
    cardTypeList: {
      type: Array,
      default: () => [],
    },
    isStore: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    scrollAmount: 0,
    scrollStep: 0,
  }),

  methods: {
    selectPackType(type) {
      this.$store.dispatch('pack/setTopCardType', type);
    },
    initializeScroll() {
      const menuItem = document.querySelector('.menu-item');
      this.scrollStep = menuItem ? menuItem.clientWidth : 0;
    },
    scrollRight() {
      const menu = document.querySelector('.menu-wrapper');
      this.initializeScroll();
      const maxScroll = menu.scrollWidth - menu.clientWidth;
      const newScrollAmount = Math.min(menu.scrollLeft + this.scrollStep, maxScroll);
      this.smoothScroll(menu, newScrollAmount);
    },
    scrollLeft() {
      const menu = document.querySelector('.menu-wrapper');
      this.initializeScroll();
      const newScrollAmount = Math.max(menu.scrollLeft - this.scrollStep, 0);
      this.smoothScroll(menu, newScrollAmount);
    },
    smoothScroll(element, targetPosition) {
      element.scrollTo({
        left: targetPosition,
        behavior: 'smooth',
      });
    },
    enableDragScroll() {
      const menu = document.querySelector('.menu-wrapper');
      let isDown = false;
      let startX;
      let scrollLeft;
      // PCのドラッグスクロール
      menu.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - menu.offsetLeft;
        scrollLeft = menu.scrollLeft;
        menu.style.cursor = 'grabbing';
      });

      menu.addEventListener('mouseleave', () => {
        isDown = false;
        menu.style.cursor = 'grab';
      });

      menu.addEventListener('mouseup', () => {
        isDown = false;
        menu.style.cursor = 'grab';
      });

      menu.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - menu.offsetLeft;
        const walk = (x - startX) * 2; // スクロール速度調整
        menu.scrollLeft = scrollLeft - walk;
      });

      // スマホのスワイプスクロール
      let touchStartX;
      let touchScrollLeft;

      menu.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].pageX - menu.offsetLeft;
        touchScrollLeft = menu.scrollLeft;
      });

      menu.addEventListener('touchmove', (e) => {
        e.preventDefault();
        const x = e.touches[0].pageX - menu.offsetLeft;
        const walk = (x - touchStartX) * 2; // スクロール速度調整
        menu.scrollLeft = touchScrollLeft - walk;
      });
    },
  },
  mounted() {
    this.enableDragScroll();
    // 初期選択はTop.vueのpackList watchで行うため、ここでは行わない
  },
};
</script>

<style lang="scss" scoped>
.pack_menu_list {
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid #ddd;
  padding: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
  margin-bottom: 15px;
}
.arrow {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.menu-wrapper {
  overflow: hidden;
  width: 100%;
  // overflow-x: auto;
  // // スクロールバーを非表示
  // &::-webkit-scrollbar {
  //   display: none;
  // }
  // -ms-overflow-style: none;
  // scrollbar-width: none;
}
.menu {
  display: flex;
  transition: transform 0.3s ease;
  gap: 10px;
  user-select: none; // ユーザーが誤ってテキストを選択しないように
  white-space: nowrap;
}
.menu-item {
  flex: 0 0 auto;
  padding: 5px 5px;
  font-size: 18px;
  color: $gray2;
  white-space: nowrap;
  width: 20%;
  text-align: center;
  font-weight: bold;
  overflow: hidden;
  cursor: pointer;
}
.menu-item.active {
  background-color: #f0a380;
  color: $white;
  border-radius: 20px;
  width: 23%;
}
@media screen and (max-width: $tabletWidth) {
  .pack_menu_list {
    margin: 10px 0;
  }
  .arrow {
    width: 25px;
    height: 25px;
  }
  .menu-item {
    padding: 7px 2px;
    font-size: 10px;
    min-width: 70px;
    width: auto;
  }
  .menu-item.active {
    width: auto;
  }
}
</style>
